export default __webpack_public_path__ + "static/media/journey_en.4e02e80e.png";